import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Inline callout used when the user is blocked from asset mutations because they
 * have not added any nominees yet.
 *
 * The backend enforces this rule with:
 * - 409 { code: 'NOMINEE_REQUIRED', ... }
 *
 * This component provides a clear explanation + CTA to add a nominee.
 */
export default function NomineeRequiredBanner({ returnTo }) {
  const navigate = useNavigate();
  const location = useLocation();

  const effectiveReturnTo = returnTo || location.pathname || '/dashboard';

  return (
    <div
      style={{
        background: '#fff7e6',
        border: '1px solid #ffe0b2',
        borderRadius: 12,
        padding: 16,
        marginBottom: 16,
        boxShadow: 'var(--shadow-soft)',
      }}
      role="status"
      aria-live="polite"
    >
      <div style={{ fontWeight: 800, color: '#5d4037', marginBottom: 6 }}>
        Add a nominee to continue
      </div>
      <div style={{ color: '#6d4c41', fontSize: 14, lineHeight: 1.4, marginBottom: 12 }}>
        Before you can add or change assets, you need at least one nominee on your account. This ensures someone you trust can access the information when needed.
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <button
          type="button"
          onClick={() =>
            navigate('/account?tab=nominees', { state: { tab: 'nominees', returnTo: effectiveReturnTo } })
          }
          style={{
            padding: '10px 14px',
            borderRadius: 12,
            border: 'none',
            background: 'var(--sage-600)',
            color: '#fff',
            fontWeight: 700,
            cursor: 'pointer',
            boxShadow: 'var(--shadow-soft)',
          }}
        >
          Add nominee
        </button>
        <button
          type="button"
          onClick={() => navigate('/account?tab=nominees', { state: { tab: 'nominees' } })}
          style={{
            padding: '10px 14px',
            borderRadius: 12,
            border: '1px solid #ffe0b2',
            background: '#fff',
            color: '#6d4c41',
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          View nominees
        </button>
      </div>
    </div>
  );
}


